import { render, staticRenderFns } from "./SalesReservationC.vue?vue&type=template&id=51f92c03&scoped=true&"
import script from "./SalesReservationC.vue?vue&type=script&lang=js&"
export * from "./SalesReservationC.vue?vue&type=script&lang=js&"
import style0 from "./SalesReservationC.vue?vue&type=style&index=0&id=51f92c03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f92c03",
  null
  
)

export default component.exports